/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconAdd6 } from "../../icons/BtnIconAdd6";
import "./style.css";

export const BtnDiamondIcon = ({
  className,
  btnIconAdd6Color = "white",
  icon = <BtnIconAdd6 className="btn-icon-add" color={btnIconAdd6Color} />,
  rectangleClassName,
}) => {
  return (
    <div className={`btn-diamond-icon ${className}`}>
      <div className="overlap-group">
        <div className={`rectangle ${rectangleClassName}`} />

        {icon}
      </div>
    </div>
  );
};

BtnDiamondIcon.propTypes = {
  btnIconAdd6Color: PropTypes.string,
};
